import React, { Component } from 'react';
import classNames from 'classnames';

export default class ReportBadge extends Component {
  render() {
    return <div className={classNames('report__badge', { 'report__badge--light': this.props.light })}/>
  }
}